import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunityGuidelinesComponent } from './community-guidelines.component';

@NgModule({
  declarations: [CommunityGuidelinesComponent],
  imports: [CommonModule],
  exports: [CommunityGuidelinesComponent]
})
export class CommunityGuidelinesModule {}
